import { TypographyH3, TypographySmall } from '../../../shared/components/ui/typography'
import React, { ReactNode } from 'react'

type ProfileStatCardProps = {
    title: string,
    value: string,
    icon: ReactNode,
}

function ProfileStatCard(props: ProfileStatCardProps) {
    return (
        <div className='border rounded px-3 py-2 w-full flex justify-between gap-5'>
            <div className='flex flex-col justify-between'>
                <TypographySmall className='text-muted-foreground text-sm'>{props.title}</TypographySmall>
                <TypographyH3 className='text-xl'>{props.value}</TypographyH3>
            </div>
            <div className='bg-primary/10 rounded-full p-3 w-12 aspect-square text-primary self-center'>
                {props.icon}
            </div>
        </div>
    )
}

export default ProfileStatCard